import React, { useEffect, useState } from 'react';
import MiddlewareLogin from '../../../../routers/MiddlewareLogin';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import { toast, ToastContainer } from 'react-toastify';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';
import { Scrollbars } from 'react-custom-scrollbars';
import { PessoaAPI } from '../../../../shared/http-requests';
import {
    AcessibillityBar,
    ModalConstructor,
    SpinnerConstructor,
    Footer,
} from '../../../../shared/components';
import { LayoutHelper } from '../../../../shared/helpers';

const SearchBar = React.lazy(() =>
    import('../../components/SearchBar/SearchBar'),
);
const GuiasConteudoPersonalizado = React.lazy(() =>
    import('../../components/BaseTemplate/GuiasConteudoPersonalizado'),
);
const InfoAsks = React.lazy(() =>
    import('../../components/BaseTemplate/InfoAsks'),
);

const Div = React.lazy(() => import('../../components/html/Div'));
const Go2Top = React.lazy(() => import('../../components/html/Go2Top'));
const MenuUsuario = React.lazy(() => import('../../components/MenuUsuario'));

function BaseTemplate({ extras = true, userLocalRx, userSessionRx, ...props }) {
    const user = userLocalRx || userSessionRx;

    const [renovar, setRenovar] = useState(false);

    useEffect(() => {
        setRenovar(
            user.renovar &&
                !user.expirado &&
                localStorage.getItem('msg_shwnd') == '1',
        );
        localStorage.removeItem('msg_shwnd');
    }, [user]);

    const renovarValidade = () => {
        props.history.push('/meupergamum/dados-pessoais');
    };

    const { t } = useTranslation();
    const [top, setTop] = useState(false);

    return (
        <Scrollbars
            autoHeight
            thumbMinSize={100}
            autoHeightMin={`100vh`}
            onScrollFrame={event => {
                setTop(event.scrollTop > 200);
            }}
            renderThumbVertical={({props, style}) => {
                return  <div {...props} style={{...style, backgroundColor: 'rgba(0, 0, 0, 0.2)', zIndex: 999, borderRadius: 'inherit'}}  className="thumb-vertical"/>;
            }}
        >
            <Div
                id="content"
                className={LayoutHelper().getRootClasses(
                    props.instituicaoRx,
                    props.acessibilidadeRx,
                )}
            >
                <AcessibillityBar showUserMenu />

                <ModalConstructor open={props.loadingRx} size="xs">
                    <div className="p-4 text-center">
                        {props.loadingRx && (
                            <div>
                                <SpinnerConstructor
                                    visible
                                    height={60}
                                    width={60}
                                    className="apergamum"
                                />
                                <div className="mt-3">
                                    <span className="preto70 s17 f400">
                                        {t('PesquisandoAguarde')}
                                    </span>
                                </div>
                            </div>
                        )}
                    </div>
                </ModalConstructor>

                <ModalConstructor
                    open={renovar}
                    size="xs"
                    title={t('Atenção')}
                    footer={<>
                        <Button
                            className="bkverde branco b-none sverde hover hpreto pad5 rad5 t10 r10 f770 s13"
                            onClick={() => renovarValidade()}
                        >
                            {t('Sim')}
                        </Button>
                        <Button
                            className="bkazul branco b-none sazul hover hpreto pad5 rad5 t10 l20 f770 s13"
                            onClick={() => setRenovar(false)}
                        >
                            {t('Não')}
                        </Button>
                    </>}
                >
                    <div className="px-4">
                        {props.instituicaoRx.msg_renovacao_consulta || (
                            <>{t('msg_renovacao_consulta')}</>
                        )}
                    </div>
                </ModalConstructor>

                <div className="" style={{position: 'relative', zIndex: '999'}}>
                    <div
                        className="d-none d-sm-block"
                        style={{ position: 'absolute', width: '100%'}}
                    >
                        <a
                            href={
                                props.instituicaoRx.link_logo_consulta
                                    ? props.instituicaoRx.link_logo_consulta
                                    : '/'
                            }
                            className="img_logo d-none d-sm-block"
                            style={{
                                backgroundImage: `url(/imagens/logo)`,
                                backgroundColor: 'rgba(255, 255, 255, 1)',
                            }}
                            target={
                                props.instituicaoRx.link_logo_consulta
                                    ? '_blank'
                                    : '_self'
                            }
                        >
                            <span className="sr-only">Logo</span>
                        </a>

                        {user ? (
                            <MenuUsuario />
                        ) : (
                            <Link
                                to={{
                                    pathname: '/login',
                                    search: `?redirect=${window.location.pathname}`,
                                }}
                                className="topLinkSpace2 pad10 hover hverde nolink bklight90 f500 sombraPadrao b-w1 b-dotted b-tema30 cortxt d-none d-sm-block"
                            >
                                <FontAwesomeIcon
                                    icon="user"
                                    className="hover1 l10 r5"
                                    fixedWidth={true}
                                />
                                {t('Login')}
                            </Link>
                        )}
                    </div>
                    <div
                        className="img_topo_biblioteca"
                        style={{
                            backgroundImage: `url(/imagens/background)`,
                            backgroundSize: 'cover',
                            backgroundRepeat: 'no-repeat',
                            backgroundPosition: 'center',
                        }}
                    >
                        {/* Área de pesquisa */}
                        {true && (
                            <div className="">
                                <SearchBar
                                    opcoesConsulta={props.opcoesConsultaRx}
                                    guiaSelecionada={props.guiaSelecionada}
                                />
                            </div>
                        )}
                    </div>
                </div>
                <Div
                    className="body"
                    onLoad={ref => {
                        ref.scrollIntoView({
                            block: 'start',
                            inline: 'nearest',
                            behavior: 'smooth',
                        });
                    }}
                >
                    {props.children}
                </Div>
                {extras && (
                    <>
                        <GuiasConteudoPersonalizado />
                        <InfoAsks />
                    </>
                )}
                {/* Novo botão para ir ao topo*/}
                <Go2Top
                    onClick={() =>
                        document.querySelector('#content').scrollIntoView({
                            block: 'start',
                            inline: 'nearest',
                            behavior: 'smooth',
                        })
                    }
                    visible={top}
                    t={t}
                />
                {/* 10/01 - Novo rodapé */}
                <Footer showLinks />
                <ToastContainer
                    autoClose={8000}
                    position={toast.POSITION.TOP_CENTER}
                />
            </Div>
        </Scrollbars>
    );
}

const mapStateToProps = state => ({
    opcoesConsultaRx: state.pesquisa.opcoesConsulta,
    instituicaoRx: state.instituicao.data,
    acessibilidadeRx: state.pageConfig.acessibilidade,
    userSessionRx: state.auth.user,
    userLocalRx: state.authPersist.user,
    loadingRx: state.pageConfig.loading,
});

export default connect(mapStateToProps)(
    withRouter(MiddlewareLogin(BaseTemplate)),
);
